import { MostSearchedResultType, SearchType } from '@/types/most-search-type';

export const mostSearchesProdData: MostSearchedResultType[] = [
  {
    type: SearchType.PRESENTIAL_CONSULTATION,
    procedures: [
      {
        id: '9b6e575e-ff69-40d1-b4b0-0360de44be40',
        code: '10101012 - 225265',
        name: 'Consulta Oftalmologista (Oftalmologia)',
        displayName: 'Oftalmologista',
        slug: 'consulta-em-consultorio-oftalmologista-oftalmologia-bd992308455b3e69e9783c84b5bde7f2',
        alias: 'Consulta Oftalmologista (Oftalmologia)',
        type: SearchType.PRESENTIAL_CONSULTATION,
      },
      {
        id: '66fee69a-5d9c-407b-9394-d928db0391a4',
        code: '10101012 - 225125',
        name: 'Consulta Clínico Geral ou Clínica Médica',
        displayName: 'Clínico Geral',
        slug: 'consulta-em-consultorio-clinico-geral-ou-clinica-medica-50ec8a8bf1563a67b77b164f6ecff1d0',
        alias: 'Consulta Clínico Geral ou Clínica Médica',
        type: SearchType.PRESENTIAL_CONSULTATION,
      },
      {
        id: 'efc5a1c7-324a-44d0-93e1-345f2982b00b',
        code: '10101012 - 225135',
        name: 'Consulta Dermatologista (Dermatologia)',
        displayName: 'Dermatologista',
        slug: 'consulta-em-consultorio-dermatologista-dermatologia-d9c7df122eea2e1e541cd1ebf2f723ea',
        alias: 'Consulta Dermatologista (Dermatologia)',
        type: SearchType.PRESENTIAL_CONSULTATION,
      },
      {
        id: '9d25a081-6304-4664-988e-dd90f3ba71b3',
        code: '10101012 - 225133',
        name: 'Consulta Psiquiatra (Psiquiatria)',
        displayName: 'Psiquiatra',
        slug: 'consulta-em-consultorio-psiquiatra-psiquiatria-a6769bf3db811873f01437d2715c5d24',
        alias: 'Consulta Psiquiatra (Psiquiatria)',
        type: SearchType.PRESENTIAL_CONSULTATION,
      },
      {
        id: 'e14d2eb6-e68c-4508-89dd-894e7912b0ca',
        code: '10000761',
        name: 'Consulta Ginecologista (Ginecologia)',
        displayName: 'Ginecologista',
        slug: 'consulta-em-consultorio-ginecologista-ginecologia-702af76970fcbae313e9f3f2265a454c',
        alias: 'Consulta Ginecologista (Ginecologia)',
        type: SearchType.PRESENTIAL_CONSULTATION,
      },
      {
        id: 'f35beb10-59c7-497d-b71b-00c92a6f3264',
        code: '10101012 - 225270',
        name: 'Consulta Ortopedista (Ortopedia e Traumatologia)',
        displayName: 'Ortopedista',
        slug: 'ortopedista',
        type: SearchType.PRESENTIAL_CONSULTATION,
      },
      {
        id: 'a8cc38c7-db21-40fb-9d3e-ca1086012dc2',
        code: '10101012 - 225275',
        name: 'Consulta Otorrinolaringologista (Otorrinolaringologia)',
        displayName: 'Otorrinolaringologista',
        slug: 'otorrinolaringologista',
        type: SearchType.PRESENTIAL_CONSULTATION,
      },
      {
        id: 'e648fb33-5d9b-41e3-a208-8d2115b005fb',
        code: '10101012 - 225285',
        name: 'Consulta Urologista (Urologia)',
        displayName: 'Urologista',
        slug: 'urologista',
        type: SearchType.PRESENTIAL_CONSULTATION,
      },
      {
        id: 'e9221a04-af54-49ef-8b6b-2f5199f0dc34',
        code: '10101012 - 225112',
        name: 'Consulta Neurologista (Neurologia)',
        displayName: 'Neurologista',
        slug: 'neurologista',
        type: SearchType.PRESENTIAL_CONSULTATION,
      },
    ],
  },
  {
    type: SearchType.ONLINE_CONSULTATION,
    procedures: [
      {
        id: 'b68d7ee7-8370-4d67-b502-fecc4f5f612b',
        code: '10002062',
        name: 'Teleconsulta - Consulta Psicologia',
        displayName: 'Psicólogo',
        slug: 'teleconsulta-consulta-psicologia-113fb9c88b04ebb56431d73ffd14bc86',
        type: SearchType.ONLINE_CONSULTATION,
      },
      {
        id: 'f64245a6-35fc-48f1-89a5-ac1388a930b1',
        code: '10002063',
        name: 'Teleconsulta - Consulta Nutricionista',
        displayName: 'Nutricionista',
        slug: 'teleconsulta-consulta-nutricionista-fd67ee614a0df67180b7a1678438c120',
        type: SearchType.ONLINE_CONSULTATION,
      },
      {
        id: '6c586f55-59c9-40bc-893b-c7536bd94f5f',
        code: '10002255',
        name: 'Teleconsulta Dermatologista',
        displayName: 'Dermatologista',
        slug: 'teleconsulta-dermatologista-05b5b2e0f38b9e9318da66a425ad3f3e',
        type: SearchType.ONLINE_CONSULTATION,
      },
      {
        id: '7b136918-6cdd-4c82-9abe-295daa9a8bb8',
        code: '10002252',
        name: 'Teleconsulta Endocrinologista',
        displayName: 'Endocrinologista',
        slug: 'teleconsulta-endocrinologista-c5f09922b08973a008b39e188bcf34b9',
        type: SearchType.ONLINE_CONSULTATION,
      },
      {
        id: '8431ef9b-61fd-4548-94a7-7369741310c2',
        code: '10002064',
        name: 'Teleconsulta Clínico Geral ou Clínica Médica',
        displayName: 'Clínico Geral',
        slug: 'teleconsulta-clinico-geral-ou-clinica-medica-3eae9af7996a4ed840249d89f534b982',
        type: SearchType.ONLINE_CONSULTATION,
      },
      {
        id: '179562f0-36df-4184-b9df-fb135ddbe6e4',
        code: '10002090',
        name: 'Teleconsulta Ginecologia',
        displayName: 'Ginecologista',
        slug: 'consulta-online-com-ginecologista-ginecologia-telemedicina',
        type: SearchType.ONLINE_CONSULTATION,
      },
      {
        id: '07bbbc9c-d70f-4906-8e7b-61d2c6db744c',
        code: '10002313',
        name: 'Teleconsulta Neurologista',
        displayName: 'Neurologista',
        slug: 'consulta-online-neurologista-telemedicina',
        type: SearchType.ONLINE_CONSULTATION,
      },
      {
        id: '385fb763-aa5b-458c-bc4b-56d0a37e4fa7',
        code: '10002137',
        name: 'Teleconsulta - Consulta Fonoaudiologia',
        displayName: 'Fonoaudiologista',
        slug: 'consulta-online-fonoaudiologia-telemedicina',
        type: SearchType.ONLINE_CONSULTATION,
      },
      {
        id: 'af1bb275-0ff0-45af-b32e-d09d23553044',
        code: '10002202',
        name: 'Teleconsulta Cardiologista',
        displayName: 'Cardiologista',
        slug: 'consulta-online-cardiologista-telemedicina',
        type: SearchType.ONLINE_CONSULTATION,
      },
    ],
  },
  {
    type: SearchType.IMAGE_EXAM,
    procedures: [
      {
        id: 'd4280190-382d-4118-98d7-6e369a8acf12',
        code: '40805018',
        name: 'Raio X Tórax 1 Incidência (AP) (Ápico - Lordótica)',
        displayName: 'Radiografia Tórax',
        slug: 'raio-x-torax-1-incidencia-ap-apico-lordotica-22fca3f1f40c1aec97e11b164b86fcd6',
        type: SearchType.IMAGE_EXAM,
      },
      {
        id: '7ffc3b1a-785f-4fa7-81dc-9f91948d5ea1',
        code: '40901769',
        name: 'Ultrassonografia ou Ecografia',
        displayName: 'Ecografia Aparelho Urinário',
        slug: 'ultrassonografia-ou-ecografia-de-aparelho-urinario-feminino-eou-masculino-rins-ureteres-e-bexiga-e2e6f30d1c932133410bb4f269fd9904',
        type: SearchType.IMAGE_EXAM,
      },
      {
        id: 'f460c2a1-c17d-405a-a00f-32e88bf84d1d',
        code: '40901300',
        name: 'Ultrassonografia ou Ecografia Transvaginal (USG)',
        displayName: 'Ecografia Transvaginal',
        slug: 'ultrassonografia-ou-ecografia-transvaginal-utero-ovario-anexos-e-vagina-6b41d340cbeb05946cca07e348b72ae1',
        alias: 'Ultrassonografia ou Ecografia Transvaginal (USG)',
        type: SearchType.IMAGE_EXAM,
      },
      {
        id: '0dbd90a0-bebe-473d-bc9e-d6dc21e8e087',
        code: '40804054',
        name: 'Raio X Joelho 2 Incidências (AP - LAT)',
        displayName: 'Raio X Joelho',
        slug: 'raio-x-joelho-2-incidencias-ap-lat-499763d0e7bb08b701c17bfd6cade5ac',
        type: SearchType.IMAGE_EXAM,
      },
      {
        id: '815871ed-900a-4726-89e2-abd4049bcd23',
        code: '41001079',
        name: 'Tomografia de Tórax ou Arcos Costais',
        displayName: 'Tomografia de Tórax',
        slug: 'tomografia-de-torax-ou-arcos-costais-3501aca9c842614e89f3b613f7c4422c',
        type: SearchType.IMAGE_EXAM,
      },
      {
        id: '4ce5bcc0-21ef-4be6-a908-0ba1dbf96b28',
        code: '40901122',
        name: 'Ultrassonografia ou Ecografia de Abdome Total (Abdome Superior, Rins, Bexiga, Aorta, Veia Cava Inferior e Adrenais)',
        displayName: 'Ecografia de Abdome',
        slug: 'ultrassonografia-ou-ecografia-de-abdome-total-abdome-superior-rins-bexiga-aorta-veia-cava-inferior-e-adrenais-f01d5306ab8a910c1fe33bd54ad62095',
        alias: 'Ultrassonografia ou Ecografia de Abdome Total',
        type: SearchType.IMAGE_EXAM,
      },
      {
        id: '9840398b-4db6-4260-92a7-44b3a3b77c8d',
        code: '40901238',
        name: 'Ultrassonografia ou Ecografia Obstétrica',
        displayName: 'Ecografia Obstétrica',
        slug: 'ultrassonografia-ou-ecografia-obstetrica-ec4ae8876c4e2035c8afd5301e300f35',
        type: SearchType.IMAGE_EXAM,
      },
      {
        id: '51712c79-8761-46ed-bec4-fe4ebf943ef0',
        code: '40901114',
        name: 'Ultrassonografia ou Ecografia de Mamas',
        displayName: 'Ecografia de Mamas',
        slug: 'ultrassonografia-ou-ecografia-de-mamas-58c1540ded983f74f82b3191a3f47292',
        type: SearchType.IMAGE_EXAM,
      },
      {
        id: '6e791149-fced-481e-a063-f0f686fe8987',
        code: '40201120',
        name: 'Endoscopia Digestiva Alta (EDA)',
        displayName: 'Endoscopia Digestiva',
        slug: 'endoscopia-digestiva-alta-eda-e20aaeac0148432309abea1ec0e81f90',
        type: SearchType.IMAGE_EXAM,
      },
    ],
  },
  {
    type: SearchType.LABORATORIAL_EXAM,
    procedures: [
      {
        id: 'fef6b80a-afa5-4995-8766-3f14caa20543',
        code: '40304361',
        name: 'Hemograma',
        displayName: 'Hemograma',
        slug: 'hemograma-completo-com-contagem-de-plaquetas-ou-fracoes-eritrograma-leucograma-plaquetas-dc9a6a6345d7d3ed142fdc614397202e',
        alias: 'Hemograma',
        type: SearchType.LABORATORIAL_EXAM,
      },
      {
        id: 'be30b91b-4a45-4634-94f9-e4d06d3ab61c',
        code: '40301630',
        name: 'Creatinina',
        displayName: 'Creatinina',
        slug: 'creatinina-pesquisa-eou-dosagem-b9452a6639e15948027afc07b192eb18',
        alias: 'Creatinina',
        type: SearchType.LABORATORIAL_EXAM,
      },
      {
        id: 'eee931fa-b064-4d8d-8342-dd3d3daf4bf7',
        code: '40316521',
        name: 'TSH',
        displayName: 'TSH',
        slug: 'tsh-hormonio-tireoestimulante-tsh-ultra-sensivel-4313968696be541b627a5dc15e8a488a',
        alias: 'TSH',
        type: SearchType.LABORATORIAL_EXAM,
      },
      {
        id: 'ce0cada0-9863-4a90-be99-d453c0126c50',
        code: '40302750',
        name: 'Lipidograma',
        displayName: 'Lipidograma',
        slug: 'perfil-lipidico-lipidograma-lipidios-totais-colesterol-trigliceridios-e-eletroforese-lipoproteinas-pesquisa-eou-dosagem-170d7c79ea0f3de52ec538ba0a7f11f3',
        alias: 'Lipidograma',
        type: SearchType.LABORATORIAL_EXAM,
      },
      {
        id: 'fc2bd614-e14d-4536-a750-74e2e8adcde5',
        code: '40302830',
        name: 'Vitamina D',
        displayName: 'Vitamina D',
        slug: 'vitamina-d-25-hidroxi-aa2b7b11908e14664b3add3cd92afcfc',
        alias: 'Vitamina D',
        type: SearchType.LABORATORIAL_EXAM,
      },
      {
        id: 'f8edbce6-895b-4549-b70d-35e15ce92b4b',
        code: '40316572',
        name: 'Vitamina B12 - pesquisa e/ou dosagem',
        displayName: 'Vitamina B12',
        slug: 'vitamina-b12-pesquisa-eou-dosagem-8688a7c5a202aae1c62f53069f86d898',
        type: SearchType.LABORATORIAL_EXAM,
      },
      {
        id: '09e94e43-3d16-44c6-b57b-98b32d59dcf3',
        code: '40302040',
        name: 'Glicose - pesquisa e/ou dosagem',
        displayName: 'Glicose',
        slug: 'glicose-glicemia-em-jejum-pesquisa-eou-dosagem-f7a73b15f83db24d2a35d0fa1df520bc',
        type: SearchType.LABORATORIAL_EXAM,
      },
      {
        id: '29da3b82-dcb7-4fcc-870e-6a951a948b1b',
        code: '40316270',
        name: 'Ferritina, dosagem',
        displayName: 'Ferritina',
        slug: 'ferritina-dosagem-31eb080b2913f092da862bd675a1a941',
        type: SearchType.LABORATORIAL_EXAM,
      },
      {
        id: '99765114-6750-4b3d-937b-8f5224a40a8d',
        code: '40316491',
        name: 'T4 Livre - Tiroxina Livre',
        displayName: 'T4',
        slug: 't4-livre-tiroxina-livre-fae3aeb7dc49a3a38b30c3203fa3f75e',
        type: SearchType.LABORATORIAL_EXAM,
      },
    ],
  },
];
